import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faPen } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/modal/modal";
import { useTranslation } from "react-i18next";

const EditCompanyPage = () => {
  const [company, setCompany] = useState(null);
  const [phones, setPhones] = useState([""]);
  const [websites, setWebsites] = useState([""]);
  const [addresses, setAddresses] = useState([""]);
  const [extraInfo, setExtraInfo] = useState("");
  const { t } = useTranslation();
  const [bgPreview, setBgPreview] = useState(null);
  const [bgFile, setBgFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [galleryFiles, setGalleryFiles] = useState([]); // Галерея файлов
  const [galleryPreviews, setGalleryPreviews] = useState([]); // Превью картинок
  const [modalMessage, setModalMessage] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const res = await fetch(
          `/api/get_user.php?id=${userId}`
        );
        const data = await res.json();

        if (data.success) {
          setCompany(data.user);

          // телефоны
          if (Array.isArray(data.phones) && data.phones.length > 0) {
            setPhones(data.phones.map((p) => p.phone));
          }

          // сайты
          if (Array.isArray(data.websites) && data.websites.length > 0) {
            setWebsites(data.websites.map((w) => w.url));
          }

          // адреса
          if (Array.isArray(data.addresses) && data.addresses.length > 0) {
            setAddresses(data.addresses.map((a) => a.address));
          }

          // extra_info
          if (data.user.extra_info) setExtraInfo(data.extraInfo || "");

          // превью картинок
          if (data.user.companyLogo) {
            setLogoPreview(
              `/api/uploads/${data.user.companyLogo}`
            );
          }
          if (data.user.background) {
            setBgPreview(
              `/api/uploads/${data.user.background}`
            );
          }
        }
      } catch (err) {
        console.error("Ошибка загрузки компании:", err);
      }
    };
    fetchCompany();
  }, []);

  const handleAddField = (setter) => {
    setter((prev) => [...prev, ""]);
  };

  const handleChange = (setter, index, value) => {
    setter((prev) => {
      const copy = [...prev];
      copy[index] = value;
      return copy;
    });
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleBgChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBgFile(file);
      setBgPreview(URL.createObjectURL(file));
    }
  };
  const handleGalleryChange = (e) => {
  const files = Array.from(e.target.files);

  if (files.length > 10) {
    setModalMessage({
      title: t("error"),
      text: t("max_gallery_photos"),
      success: false,
      ok: t("ok"),
    });
    return;
  }
const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
  // ❗ ФИЛЬТР ПО РАЗМЕРУ
  const validFiles = files.filter(file => file.size <= MAX_FILE_SIZE);

  if (validFiles.length !== files.length) {
    setModalMessage({
      title: t("error"),
      text: t("large_files"),
      success: false,
      ok: t("ok"),
    });
  }

  setGalleryFiles(validFiles);
  setGalleryPreviews(validFiles.map(file => URL.createObjectURL(file)));
};

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const userId = localStorage.getItem("userId");
      const formData = new FormData();
      formData.append("id", userId);

      phones.forEach((p, i) => formData.append(`phones[${i}]`, p));
      websites.forEach((w, i) => formData.append(`websites[${i}]`, w));
      addresses.forEach((a, i) => formData.append(`addresses[${i}]`, a));

      formData.append("extraInfo", extraInfo);

      if (bgFile) formData.append("bgimage", bgFile);
      const fileInput = document.getElementById("logoUpload");
      if (fileInput && fileInput.files[0])
        formData.append("logo", fileInput.files[0]);

      // Добавляем галерею
      galleryFiles.forEach((file) => {
        formData.append("gallery[]", file);
      });

      const res = await fetch("/api/update_user.php", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (data.success) {
        navigate(`/ViewCompanyPage/${userId}`);
        setModalMessage({
          title: t("data_saved"),
          text: t("data_saved_message"),
          success: true,
          ok: t("ok"),
        });
      } else {
        alert("❌ Ошибка: " + data.message);
      }
    } catch (err) {
      console.error("Ошибка сохранения:", err);
    }
  };

  if (!company) return <p className="text-center mt-10">Загрузка...</p>;

  return (
    <section className="max-w-7xl max-lg-w-full m-auto bg-white min-h-screen">
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          success={modalMessage.success}
          ok={modalMessage.ok}
          onClose={() => setModalMessage(null)}
        />
      )}

      {/* Фон */}
      <div className="backimg relative w-full h-[230px] max-md:h-[120px] border-b-4 border-[#006674]">
        <label
          htmlFor="bgimage"
          className="size-full bg-gray-600 text-white flex justify-center items-center text-3xl cursor-pointer"
        >
          {bgPreview ? (
            <img
              src={bgPreview}
              alt="preview"
              className="size-full object-cover"
            />
          ) : (
            "Ներբեռնել լուսանկար"
          )}
        </label>
        <input
          type="file"
          id="bgimage"
          className="hidden"
          onChange={handleBgChange}
        />

        {/* Логотип */}
        <div className="absolute top-44 max-md:top-20 left-6">
          <div className="relative w-[160px] h-[160px] max-md:w-[130px] max-md:h-[130px] ">
            <img
              src={logoPreview || ""}
              className="w-full h-full shadow-2xl object-contain rounded-xl bg-gray-300"
              alt="company logo"
            />
            <label
              htmlFor="logoUpload"
              className="absolute bottom-2 right-2 bg-[#006674] text-white p-2 w-[35px] flex justify-center items-center h-[35px] rounded-full cursor-pointer hover:bg-[#004c55]"
            >
              <FontAwesomeIcon icon={faPen} />
            </label>
            <input
              type="file"
              id="logoUpload"
              className="hidden"
              onChange={handleLogoChange}
            />
          </div>
        </div>
      </div>

      <h1 className="companyname text-4xl  max-lg:text-2xl  font-medium text-[#006674] pb-6 uppercase pl-52 max-md:pl-44 mt-6">
        {company.companyName}
      </h1>

      {/* <hr className="w-full h-[1px] mt-12 border-[#006674]" /> */}

      <form
        onSubmit={handleSave}
        className="p-6 max-md:p-3 mt-12 flex flex-col gap-6"
      >
        {/* Extra Info */}
        <h3 className="text-2xl max-sm:text-xl mb-3 text-[#006674]">
          {t("information")}
        </h3>
        <textarea
          value={extraInfo}
          onChange={(e) => setExtraInfo(e.target.value)}
          className="w-[500px] h-[100px] max-md:w-full py-2 px-3 rounded outline-none transition-all duration-200 border-[1px] border-gray-300 focus:border-[#006674]"
        ></textarea>

        {/* Телефоны */}
        <div>
          <h3 className="text-2xl max-sm:text-xl mb-3 text-[#006674]">
            {t("telephone")}
          </h3>
          {phones.map((phone, i) => (
            <div key={i} className="flex items-center gap-2 mb-2">
              <input
                type="text"
                value={phone}
                onChange={(e) => handleChange(setPhones, i, e.target.value)}
                className="w-[500px] max-md:w-80 p-2 rounded border border-gray-300 focus:border-[#006674] outline-none"
              />
              {i === 0 && (
                <button
                  type="button"
                  onClick={() => handleAddField(setPhones)}
                  className="w-[40px] h-[40px] bg-[#006674] text-white rounded-full hover:bg-[#004c55]"
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Сайты */}
        <div>
          <h3 className="text-2xl max-sm:text-xl mb-3 text-[#006674]">
            {t("websiteurl")}
          </h3>
          {websites.map((site, i) => (
            <div key={i} className="flex items-center gap-2 mb-2">
              <input
                type="text"
                value={site}
                onChange={(e) => handleChange(setWebsites, i, e.target.value)}
                className="w-[500px] max-md:w-80 p-2 rounded border border-gray-300 focus:border-[#006674] outline-none"
              />
              {i === 0 && (
                <button
                  type="button"
                  onClick={() => handleAddField(setWebsites)}
                  className="w-[40px] h-[40px] bg-[#006674] text-white rounded-full hover:bg-[#004c55]"
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Адреса */}
        <div>
          <h3 className="text-2xl max-sm:text-xl mb-3 text-[#006674]">
            {t("locationaddres")}
          </h3>
          {addresses.map((addr, i) => (
            <div key={i} className="flex items-center gap-2 mb-2">
              <input
                type="text"
                value={addr}
                onChange={(e) => handleChange(setAddresses, i, e.target.value)}
                className="w-[500px] max-md:w-80 p-2 rounded border border-gray-300 focus:border-[#006674] outline-none"
              />
              {i === 0 && (
                <button
                  type="button"
                  onClick={() => handleAddField(setAddresses)}
                  className="w-[40px] h-[40px] bg-[#006674] text-white rounded-full hover:bg-[#004c55]"
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Галерея */}
        <div>
          <h3 className="text-2xl max-sm:text-xl mb-6 text-[#006674]">
            {t("photos")}
          </h3>
          <div className="flex justify-start items-center gap-3">
            <label
              htmlFor="galleryUpload"
              className="cursor-pointer px-4 w-[200px] h-[100px] border-dashed border-white border-[2px] flex justify-center items-center py-2 bg-[#006674] text-white rounded-lg hover:bg-[#004c55]"
            >
              <FontAwesomeIcon icon={faPlus} />
            </label>
            <h3>{t("maxphoto")}</h3>
            <input
              type="file"
              id="galleryUpload"
              className="hidden"
              multiple
              onChange={handleGalleryChange}
            />
          </div>

          {/* Превью выбранных картинок */}
          <div className="mt-4 grid grid-cols-4 gap-4">
            {galleryPreviews.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`gallery-${i}`}
                className="w-full h-32 object-cover rounded shadow"
              />
            ))}
          </div>
        </div>

            <button
          type="submit"
          className="mt-6 px-6 w-[150px]  py-2 bg-[#006674] text-white rounded-lg hover:bg-[#004c55]"
        >
          {t("save")}
        </button>
      </form>
    </section>
  );
};

export default EditCompanyPage;
